export default __webpack_public_path__ + "static/media/Mobile.03be45e3.svg";